<template>
  <div id="portfolio">
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <div v-if="user.activeStatus && user.activeStatus !== 'active'" class="mt-4">
        <v-alert color="softBackgroundGreen" icon="mdi-account-convert">
          <p class="inactive-actions-text">
            {{ $t('views.stocks.inactiveActions1') }}
          </p>
          <div class="d-flex">
            <p class="mb-0">
              {{ $t('views.stocks.inactiveActions2') }}
            </p>
            <v-progress-circular
              class="ml-3 mb-1"
              size="15"
              width="2"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-alert>
      </div>
      <AccountPastDueAlert showGoToAccount />

      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab
          v-for="broker in tabItems"
          :key="broker._id"
          :href="'#' + broker._id"
          active-class="v-tab-active-class"
        >
          <span v-if="broker.name === 'all'">
            <b>{{ $t(`views.portfolio.tabs.all`) }}</b>
          </span>
          <span v-else>{{ broker.alias }}</span>
        </v-tab>
      </v-tabs>
    </v-container>

    <v-container class="tabs-items" fluid tag="section">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item
          v-for="broker in tabItems"
          :key="broker._id"
          :value="broker._id"
          :transition="false"
          :reverse-transition="false"
        >
          <PortfolioByBroker
            :ref="'portfolio-by-broker-' + broker._id"
            :broker="broker"
            @loadAllPortfolioByBroker="loadAllPortfolioByBroker"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import gtag from '@/lib/gtag'
import visibilityMixin from '@/views/components/core/visibilityMixin'
import { mapActions, mapState } from 'vuex'
import { getBrokersActivePositions } from '@/lib/api.js'
import AccountPastDueAlert from '@/views/components/account/AccountPastDueAlert'
import PortfolioByBroker from '@/views/components/portfolio/PortfolioByBroker.vue'

export default {
  components: {
    AccountPastDueAlert,
    PortfolioByBroker,
  },
  mixins: [visibilityMixin],
  data: () => ({
    tabItems: undefined,
    tab: null,
    loadTimeout: null,
  }),
  computed: {
    ...mapState(['user']),
  },
  watch: {
    tab() {
      gtag.pageview({
        pagePath: `/portfolio/${this.tab}`,
        pageTitle: `portfolio|${this.tab}`,
        pageContentGroup: 'page',
      })
    },
  },
  async destroyed() {
    clearTimeout(this.loadTimeout)
  },
  async created() {
    const brokersActivePositions = await getBrokersActivePositions()
    this.tabItems = [{ _id: 'all', name: 'all' }, ...brokersActivePositions.data]

    this.loadUser()
  },
  methods: {
    ...mapActions({ updateUsersInfo: 'UPDATE_USERS_INFO' }),
    async loadUser() {
      clearTimeout(this.loadTimeout)
      if (this.user.activeStatus !== 'active') {
        this.loadTimeout = setTimeout(() => {
          this.updateUsersInfo()
          this.loadUser()
        }, 10000)
      }
    },
    loadAllPortfolioByBroker() {
      for (const broker of this.tabItems) {
        const refName = `portfolio-by-broker-${broker._id}`
        const ref = this.$refs[refName]
        const brokerComponent = Array.isArray(ref) ? ref[0] : ref

        if (brokerComponent && typeof brokerComponent.loadAll === 'function') {
          brokerComponent.loadAll()
        }
      }
    },
  },
}
</script>
